import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFlow } from '../../contexts/FlowContext';

interface RequireAuthProps {
  children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { state } = useFlow();

  if (!state.accessToken || !state.personId) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
};
